import { useState } from 'react';

import { StyleSheet } from 'react-native';

import { IServerOrder } from '@rbi-ctg/menu';
import { FavoriteOrderButton } from 'components/favorite-order-button';
import { ItemThumbnailWithBadge } from 'components/item-thumbnail-with-badge/item-thumbnail-with-badge';
import { Box } from 'components/ui/box';
import { useOrderDetailsCard } from 'hooks/use-order-details-card';
import { t } from 'state/intl/translations';
import { spacing } from 'styles/constants';

import { ModalOrderDetails } from './modal-order-details';
import { CardContainer, ItemName, Price, StyledLink } from './styled';

export const OrderDetailsCard = ({ order }: { order: IServerOrder }) => {
  const { itemHighlighted, totalPrice, totalItems } = useOrderDetailsCard(order);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);

  return (
    <CardContainer>
      {itemHighlighted && <ItemThumbnailWithBadge item={itemHighlighted} totalItems={totalItems} />}
      <Box style={styles.itemDetailsContainer}>
        <Price>{totalPrice}</Price>
        <ItemName numberOfLines={1}>{itemHighlighted?.name}</ItemName>
        <StyledLink marginTop="$2" onPress={() => setIsDetailsModalOpen(true)}>
          {t('viewDetails')}
        </StyledLink>
      </Box>
      <Box style={styles.favoriteButtonContainer}>
        <FavoriteOrderButton order={order} />
      </Box>
      <ModalOrderDetails
        serverOrder={order}
        showModal={isDetailsModalOpen}
        onCloseModal={() => setIsDetailsModalOpen(false)}
      />
    </CardContainer>
  );
};

const styles = StyleSheet.create({
  favoriteButtonContainer: {
    alignSelf: 'flex-start',
  },
  itemDetailsContainer: {
    flex: 1,
    marginLeft: spacing.$4,
  },
});
